import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const BulkCountAppEndPoints = {
  SENT_COUNT: 'SENT_COUNT',
  VENDOR_LIST_BY_FACTORY_ID: 'VENDOR_LIST',
  BCTX_WISE_SENT_QUANTITY: 'BCTX_WISE_SENT_QUANTITY',
  BCTX_WISE_WIP_QUANTITY: 'BCTX_WISE_SENT_QUANTITY',
  BULK_SEND_SAVE_EVENT: 'BULK_SEND_SAVE_EVENT',
  SEND_TRASACTION_LISTING: 'SEND_TRASACTION_LISTING',
  SEND_TRANSACTION_UNDO: 'SEND_TRANSACTION_UNDO',
  RECEIVE_COUNT: 'RECEIVE_COUNT',
  VENDORS_TO_BCTX_COMBINATION_DATA: 'VENDORS_TO_BCTX_COMBINATION_DATA',
  BULK_RECEIVE_SAVE_EVENT: 'BULK_RECEIVE_SAVE_EVENT',
  RECEIVE_TRASACTION_LISTING: 'RECEIVE_TRASACTION_LISTING',
  RECEIVE_TRANSACTION_UNDO: 'RECEIVE_TRANSACTION_UNDO',
};

type TBulkCountAppEndPoints = typeof BulkCountAppEndPoints;
type TBulkCountAppEndPointsTypes = keyof TBulkCountAppEndPoints;

@Injectable({ providedIn: 'root' })
export class BulkCountAppEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TBulkCountAppEndPoints = {
    VENDOR_LIST_BY_FACTORY_ID: '',
    SENT_COUNT: '',
    BCTX_WISE_SENT_QUANTITY: '',
    BCTX_WISE_WIP_QUANTITY: '',
    BULK_SEND_SAVE_EVENT: '',
    SEND_TRASACTION_LISTING: '',
    SEND_TRANSACTION_UNDO: '',
    RECEIVE_COUNT: '',
    VENDORS_TO_BCTX_COMBINATION_DATA: '',
    BULK_RECEIVE_SAVE_EVENT: '',
    RECEIVE_TRASACTION_LISTING: '',
    RECEIVE_TRANSACTION_UNDO: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;
    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.SENT_COUNT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/sent/quantity';
    this.env_vars.VENDOR_LIST_BY_FACTORY_ID =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/vendors';
    this.env_vars.BCTX_WISE_SENT_QUANTITY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/sent/list';
    this.env_vars.BCTX_WISE_WIP_QUANTITY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/bctx/wip';
    this.env_vars.BULK_SEND_SAVE_EVENT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/bulkSaveSend';
    this.env_vars.SEND_TRASACTION_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/send/transactions';
    this.env_vars.SEND_TRANSACTION_UNDO =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/send/undo';
    this.env_vars.RECEIVE_COUNT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/receive/quantity';
    this.env_vars.VENDORS_TO_BCTX_COMBINATION_DATA =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/receive/getAllBctxData';
    this.env_vars.BULK_RECEIVE_SAVE_EVENT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/bulkSaveReceive';
    this.env_vars.RECEIVE_TRASACTION_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/receive/transactions';
    this.env_vars.RECEIVE_TRANSACTION_UNDO =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/receive/undo';
  }

  public getEnvVar(arg: TBulkCountAppEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
